import type { ReactNode } from 'react';
import { Button } from '@/shared/components';
import { effectLabel, type InlineEditorValues } from '../calendar/inlineEditorModel';
import { totalNights, type SelectedRange } from '../calendar/rangeSelectionModel';
import { daysLabel } from './monthEditorModel';

/** Ohne Auswahl: was zu tun ist, und nach dem Vormerken, wo der Stand steht. */
export function MonthEditorEmpty({ done, children }: { done: boolean; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-3 px-[22px] py-7">
      <span className="font-serif text-[22px] font-bold">Zeitraum wählen</span>
      <span className="text-ink-soft text-sm leading-relaxed">
        Klicke im Kalender auf den ersten und den letzten Tag. Danach setzt du hier Preis,
        Mindestnächte oder eine Sperre.
      </span>
      {children}
      {done && (
        <span
          role="status"
          className="bg-forest-soft text-forest-deep rounded-control px-3.5 py-3 text-[13px] font-semibold"
        >
          Änderungen vorgemerkt – sie werden an Channex übertragen. Den Stand siehst du oben im
          Kopf.
        </span>
      )}
    </div>
  );
}

export function MonthEditorFooter({
  apartmentName,
  ranges,
  availability,
  busy,
  onReview,
  onDiscard,
}: {
  apartmentName: string;
  ranges: readonly SelectedRange[];
  availability: InlineEditorValues['availability'];
  busy: boolean;
  onReview: () => void;
  onDiscard: () => void;
}) {
  const count = totalNights(ranges);
  return (
    // Klebt am Boden: im Handy-Blatt bleibt „Änderungen prüfen“ ohne Scrollen im Bild (§8).
    <div className="border-hairline bg-card sticky bottom-0 mt-auto flex flex-col gap-3 border-t px-[22px] pb-[22px] pt-[18px]">
      <span className="text-ink-soft text-[13px]">
        Nur {apartmentName} · {daysLabel(count)}{' '}
        {count === 1
          ? effectLabel(availability).replace('werden', 'wird')
          : effectLabel(availability)}
        . Leere Felder bleiben, wie sie sind.
      </span>
      <div className="flex gap-2">
        <Button
          variant="brand"
          className="rounded-pill h-12 grow"
          onClick={onReview}
          loading={busy}
        >
          Änderungen prüfen
        </Button>
        <Button
          variant="ghost"
          className="rounded-pill border-line h-12 border px-4"
          onClick={onDiscard}
          disabled={busy}
        >
          Verwerfen
        </Button>
      </div>
    </div>
  );
}
